import SuiTypography from "components/SuiTypography";
import Tooltip from "@mui/material/Tooltip";
import { globaleDateTimeFormatter } from "utils/helper";
import TableAction from "containers/table-action";
import { htmlToText } from "html-to-text";

export const templateRows = (
  templateArray,
  viewHandler,
  updateHandler,
  deleteHandler
) => {
  const rows_ = templateArray.map((item, index) => {
    return {
      "S.no": (
        <SuiTypography
          variant="button"
          fontWeight="medium"
          style={{ paddingLeft: 14 }}
        >
          {index + 1}
        </SuiTypography>
      ),

      "Date/Time (Added)": (
        <SuiTypography variant="button" fontWeight="medium" style={{}}>
          {item.createdAt ? globaleDateTimeFormatter(item?.createdAt) : "N/A"}
        </SuiTypography>
      ),

      Name: (
        <SuiTypography variant="button" style={{}} fontWeight="medium">
          {item?.name}
        </SuiTypography>
      ),
      "Chart Type": (
        <SuiTypography variant="button" style={{}} fontWeight="medium">
          {item?.chartType.value || "N/A"}
        </SuiTypography>
      ),

      "Week Plan": (
        <SuiTypography variant="button" style={{}} fontWeight="medium">
          {item?.weekPlan.value}
        </SuiTypography>
      ),

      Notes: (
        <Tooltip
          title={item?.note ? htmlToText(item.note) : "N/A"}
          placement="top"
        >
          <SuiTypography variant="button" fontWeight="medium">
            {item?.note
              ? htmlToText(item.note).length > 20
                ? `${htmlToText(item.note).slice(0, 20)}...`
                : htmlToText(item.note)
              : "N/A"}
          </SuiTypography>
        </Tooltip>
      ),

      Actions: (
        <TableAction
          iconStyle={{}}
          style={{ padding: "3px", marginLeft: "5px" }}
          viewHandler={() => viewHandler(item)}
          updateHandler={() => updateHandler(item)}
          deleteHandler={() => deleteHandler(item)}
        />
      ),
    };
  });
  return rows_;
};
